module.exports = __webpack_public_path__ + "img/leaf.ad0bdf77.svg";